import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { bool, func, string } from 'prop-types';
import translate from '@/lib/intl/translate';

function ConfirmationPopup({
  confirmButtonLabel,
  message,
  onConfirm,
  onClose,
  open,
  ...rest
}) {
  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      sx={{ margin: '0 10px' }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...rest}
    >
      <Box p={3} sx={{ width: '275px' }}>
        <Typography>{message}</Typography>
        <Box
          display="flex"
          flex="1"
          flexDirection="row"
          justifyContent="space-between"
          pt={2}
          sx={{ gap: 1 }}
        >
          <Button
            data-testid="confirmation-popup-cancel-button"
            onClick={onClose}
          >
            {translate('CANCEL')}
          </Button>
          <Button
            data-testid="confirmation-popup-confirm-button"
            onClick={onConfirm}
            variant="contained"
          >
            {confirmButtonLabel}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
}

ConfirmationPopup.propTypes = {
  confirmButtonLabel: string.isRequired,
  message: string.isRequired,
  onConfirm: func.isRequired,
  onClose: func.isRequired,
  open: bool.isRequired,
};

export default ConfirmationPopup;
